import { provideHttpClient } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import themes from 'devextreme/ui/themes';
import Tooltip from 'devextreme/ui/tooltip';
import { App } from './app/app';
import { appConfig, RUNTIME_CONFIG } from './app/app.config';
import { provideAuthForConfig } from './app/auth/auth.providers';
import { licenseKey } from './devextreme-license';
import { environment } from './environments/environment';
import { Environment } from './environments/environment.model';

async function main(): Promise<void> {
    let runtimeConfig: Environment = environment as unknown as Environment;

    const tryUrls = environment.name ? [`/assets/config.${environment.name}.json`, `/assets/config.json`] : [`/assets/config.json`];

    let loaded = false;
    for (const url of tryUrls) {
        try {
            const resp = await fetch(url, { cache: 'no-cache' });
            if (resp.ok) {
                runtimeConfig = (await resp.json()) as Environment;
                loaded = true;
                break;
            }
        } catch {
            // error of loading file
        }
    }
    if (!loaded) {
        console.warn('No runtime config found, using environment.ts');
        runtimeConfig = environment;
    }

    await bootstrapApplication(App, {
        ...appConfig,
        providers: [
            { provide: RUNTIME_CONFIG, useValue: runtimeConfig },
            provideAuthForConfig(runtimeConfig),
            ...appConfig.providers,
            provideHttpClient(),
        ],
    });
}

config({ licenseKey });
Tooltip.defaultOptions({
    options: {
        showEvent: { name: 'mouseenter', delay: 300 },
        hideEvent: { name: 'mouseleave' },
        position: 'bottom',
    },
});

themes.initialized(() => {
    main();
});
